import {
  faCreditCard,
  faVault,
  faArrowRightArrowLeft,
  faSackDollar,
  faCashRegister,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCashboxes } from '@redux/features/cashboxesSlice';
import { getEntityLink } from 'helpers/getEntityLink';
import { CASHBOX_TYPES } from 'constants/cashboxTypes';
import { Button } from 'components/Button';
import { CreateTransferForm } from './forms/CreateTransferForm';
import { PaymentMethodsForm } from './forms/PaymentMethodsForm';
import { CreateAccountForm } from './forms/CreateAccountForm';
import { EditAccountForm } from './forms/EditAccountForm';
import { AddCashboxCard } from './AddCashboxCard';
import { CashboxCard } from './CashboxCard';
import { Total } from './Total';
import { Hero } from './Hero';
import styles from './Cashboxes.scss';

export const Cashboxes = () => {
  const { cashboxes } = useSelector((state) => state.cashboxes);
  const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] = useState(false);
  const [paymentMethodsCashbox, setPaymentMethodsCashbox] = useState(null);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [initialFromCashbox, setInitialFromCashbox] = useState(null);
  const [editingCashbox, setEditingCashbox] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getCashboxes());
  }, []);

  const handleTransferOpen = (e, fromCashbox = null) => {
    e.stopPropagation();

    setInitialFromCashbox(fromCashbox);
    setIsTransferModalOpen(true);
  };

  const totalBalance = useMemo(() => cashboxes.reduce((sum, cashbox) => sum + cashbox.balance, 0), [cashboxes]);

  const mainCashbox = cashboxes.find((c) => c.type === CASHBOX_TYPES.MAIN);
  const accountCashboxes = cashboxes.filter((c) => c.type === CASHBOX_TYPES.ACCOUNT);
  const registerCashboxes = cashboxes.filter((c) => c.type === CASHBOX_TYPES.REGISTER);
  const locationCashboxes = cashboxes.filter((c) => c.type === CASHBOX_TYPES.SAFE);

  return (
    <div className={styles.cashboxes}>
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <h1>
            <FontAwesomeIcon icon={faSackDollar} />
            Управління фінансами
          </h1>
          <p>Огляд всіх рахунків та сейфів</p>
        </div>
        <Button className={styles.transferButton} onClick={handleTransferOpen} smallStyle>
          <FontAwesomeIcon icon={faArrowRightArrowLeft} />
          Переказ між рахунками
        </Button>
      </div>

      <div className={styles.main}>
        {mainCashbox && <Hero mainCashbox={mainCashbox} handleTransferOpen={handleTransferOpen} />}
        <Total totalBalance={totalBalance} />
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>
          <FontAwesomeIcon icon={faCreditCard} />
          Банківські рахунки
        </h2>
        <div className={styles.compactGrid}>
          {accountCashboxes.map((cashbox, i) => (
            <CashboxCard
              cashbox={cashbox}
              handleTransferOpen={handleTransferOpen}
              setEditingCashbox={setEditingCashbox}
              setPaymentMethodsCashbox={setPaymentMethodsCashbox}
              index={i}
              key={cashbox.id}
            />
          ))}
          <AddCashboxCard onClick={() => setIsCreateAccountModalOpen(true)} type={CASHBOX_TYPES.ACCOUNT} />
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>
          <FontAwesomeIcon icon={faCashRegister} />
          Каса
        </h2>
        <div className={styles.compactGrid}>
          {registerCashboxes.map((cashbox, i) => (
            <CashboxCard
              cashbox={cashbox}
              handleTransferOpen={handleTransferOpen}
              setEditingCashbox={setEditingCashbox}
              setPaymentMethodsCashbox={setPaymentMethodsCashbox}
              index={i}
              key={cashbox.id}
            />
          ))}
          <AddCashboxCard onClick={() => navigate(getEntityLink('locations'))} type={CASHBOX_TYPES.REGISTER} />
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>
          <FontAwesomeIcon icon={faVault} />
          Сейфи локацій
        </h2>
        <div className={styles.compactGrid}>
          {locationCashboxes.map((cashbox, i) => (
            <CashboxCard
              cashbox={cashbox}
              handleTransferOpen={handleTransferOpen}
              setEditingCashbox={setEditingCashbox}
              index={accountCashboxes.length + i}
              key={cashbox.id}
            />
          ))}
          <AddCashboxCard onClick={() => navigate(getEntityLink('locations'))} type={CASHBOX_TYPES.SAFE} />
        </div>
      </div>

      <CreateTransferForm
        cashboxes={cashboxes}
        isOpen={isTransferModalOpen}
        setIsOpen={setIsTransferModalOpen}
        initialFromCashbox={initialFromCashbox}
      />

      <PaymentMethodsForm
        cashbox={paymentMethodsCashbox}
        isOpen={paymentMethodsCashbox}
        setIsOpen={setPaymentMethodsCashbox}
      />

      <EditAccountForm cashbox={editingCashbox} isOpen={editingCashbox} setIsOpen={setEditingCashbox} />
      <CreateAccountForm isOpen={isCreateAccountModalOpen} setIsOpen={setIsCreateAccountModalOpen} />
    </div>
  );
};
